module.exports = __webpack_public_path__ + "img/notestconfig.4686e7ab.svg";